/**
 * 快速操作类型枚举
 */
export enum QuickActionType {
  Pinned = 0,           // 置顶
  AdvanceSingleStep = 1, // 上移
  FutureSingleStep = 2,  // 下移
  Trailing = 3,         // 置底
}

/**
 * 快速操作按钮配置
 */
export const QUICK_ACTIONS = [
  { type: 'pinned', action: QuickActionType.Pinned },
  { type: 'advanceSingleStep', action: QuickActionType.AdvanceSingleStep },
  { type: 'futureSingleStep', action: QuickActionType.FutureSingleStep },
  { type: 'trailing', action: QuickActionType.Trailing },
] as const;

/**
 * 默认样式类名
 */
export const DEFAULT_CLASS_NAMES = {
  chosen: 'dbl-item-chosen',
  drag: 'dbl-item-dragging',
  ghost: 'dbl-item-ghost',
  active: 'dbl-item-active',
} as const;

/**
 * 默认配置
 */
export const DEFAULT_CONFIG = {
  itemHeight: 40,
  overscan: 10,
  animation: 150,
} as const;

